import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';
import { ShieldCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const METRIC_ACCENT = {
  detox: '#FF6B4A', inflammation: '#A388EE', gut: '#4ADE80', hydration: '#FF6B4A', hormone: '#A388EE',
};

const MethodologyDialog = ({ open, onOpenChange }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (open && !data) {
      axios.get(`${API}/score/methodology`).then((r) => setData(r.data)).catch(() => {});
    }
  }, [open, data]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg rounded-2xl bg-white max-h-[85vh] p-0" data-testid="methodology-dialog">
        <DialogHeader className="p-6 pb-3">
          <DialogTitle className="font-heading text-xl text-[#1A1514] flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-[#4ADE80]" /> How your scores are calculated
          </DialogTitle>
          <DialogDescription className="text-sm text-[#8C7A76]">
            Evidence-informed, transparent, and built from your own logs.
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[62vh] px-6 pb-6">
          {!data ? (
            <p className="text-sm text-[#8C7A76] py-8 text-center">Loading methodology…</p>
          ) : (
            <div className="space-y-4">
              <div className="bg-[#FFF2EC] rounded-xl p-4">
                <p className="text-[11px] text-[#8C7A76] leading-relaxed" data-testid="methodology-disclaimer">{data.disclaimer}</p>
              </div>

              {data.metrics.map((m) => (
                <div key={m.key} className="border border-[#E5D0C9] rounded-xl p-4" data-testid={`methodology-metric-${m.key}`}>
                  <div className="flex items-center justify-between mb-1">
                    <h4 className="font-heading font-bold text-sm text-[#1A1514]">{m.name}</h4>
                    <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full text-white" style={{ backgroundColor: METRIC_ACCENT[m.key] || '#FF6B4A' }}>{m.weight}</span>
                  </div>
                  <p className="text-xs text-[#8C7A76] mb-2 leading-relaxed">{m.summary}</p>
                  <ul className="space-y-1">
                    {m.inputs.map((inp) => (
                      <li key={inp} className="text-[11px] text-[#1A1514] flex items-start gap-2">
                        <span className="text-[#4ADE80] mt-0.5">&#9679;</span>{inp}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

              <div>
                <p className="text-xs font-semibold text-[#1A1514] uppercase tracking-wider mb-2">Research citations</p>
                <ul className="space-y-1">
                  {data.citations.map((c) => (
                    <li key={c} className="text-[10px] text-[#8C7A76] italic leading-relaxed">{c}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default MethodologyDialog;
